
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySleetShowersDayColour as ObiLightningHeavySleetShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-sleet-showers-day-colour.js';
 
 
 

 
 export const ObiLightningHeavySleetShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-sleet-showers-day-colour',
   elementClass: ObiLightningHeavySleetShowersDayColourElement,
   events: {
     
   }
  });
 
 